import {createAction} from 'redux-act'

export const fetchGraphRequest = createAction('Request to fetch graph')
export const fetchGraphSuccess = createAction('Success in fetching graph')
export const fetchGraphFailure = createAction('Failure in fetching graph')
